export default "__VITE_ASSET__7115bb10__"